module.exports = __webpack_public_path__ + "img/card7.99cb7d49.jpg";